/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Logo } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { jsonHasValue, callFxgApi, FxComponentWrapper } from 'axp-fx-common'; // eslint-disable-line no-unused-vars
import registerStyles from '../../styles/registerStyles';
// eslint-disable-next-line no-unused-vars
import Banner from './Banner/Banner';
import { apiPaths } from '../../constants/paths';
// eslint-disable-next-line no-unused-vars
import Welcome from './Registration/Welcome';
import { getRegistrationErrorDetail } from '../../utils/errorUtil';
// eslint-disable-next-line no-unused-vars
import Registration from './Registration/Registration';
// eslint-disable-next-line no-unused-vars
import RegistrationSuccessPage from './Registration/RegistrationSuccessPage';
// eslint-disable-next-line no-unused-vars
import RegistrationErrorPage from './Registration/RegistrationErrorPage';

const Register = () => {
  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const [errorData, setErrorData] = useState({});
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  const [isRegistrationSucces, setIsRegistrationSuccess] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const [registrationLocation] = useState(window.location);
  const urlParams = new URLSearchParams(registrationLocation.search);
  const regId = urlParams.get('reqId');
  const rsvpCd = urlParams.get('rsvpCd');

  /**
   * validate RSVP code on load of the welcome page
   *
   * step1: reset the errorData
   * step2: api call to validate rsvp code
   * step3: if rsvp code is invalid or expired, set the error data
   */
  useEffect(() => {
    const verifyRsvp = async () => {
      setErrorData({});
      setShowLoader(true);
      const requestData = {
        regId,
        rsvpCd,
      };
      const { response, hasErrors } = await callFxgApi(
           `${fxgApiHost}${apiPaths.verifyRsvpCd}`,
        'POST',
        requestData
      );
      if (hasErrors) {
        const { status, message, additionalMessage } = getRegistrationErrorDetail(
          response?.errorCd
        );
        const err = {
          status,
          errorMessage: message || response?.errorMsg,
          additionalMessage,
        };
        setErrorData(err);
      }
      setShowLoader(false);
    };

    verifyRsvp();
  }, []); // initial load only with URL params

  // on Click on continue of the registration page, trigger the registration form
  const onContinueClick = () => {
    setShowRegistrationForm(true);
  };

  /**
   *
   * @returns component to be displayed during registration flow
   *
   * If any error exists, display the error data.
   * On continue of the registration page, show the regiatration form.
   * Default return the Welcome page to the user.
   */
  const renderPage = () => {
    if (jsonHasValue(errorData)) {
      return <RegistrationErrorPage errorData={errorData} />;
    }
    if (isRegistrationSucces) {
      return <RegistrationSuccessPage />;
    }
    if (showRegistrationForm) {
      return (
        <Registration
          setErrorData={setErrorData}
          setIsRegistrationSuccess={setIsRegistrationSuccess}
          registrationLocation={registrationLocation}
          regId={regId}
          rsvpCd={rsvpCd}
        />
      );
    }
    return <Welcome onContinueClick={onContinueClick} />;
  };

  return (
    <div className="pad" css={registerStyles['.pageContainer']}>
      <div id="container" css={registerStyles['.backgroundContainer']}>
        <div id="left-container" css={registerStyles['.banner']}>
          <Banner />
        </div>
        <div
          id="right-container"
          className="dls-white-bg"
          css={registerStyles['.registration']}
        >
          <Logo alt="American Express" size="" styleType="bluebox-solid" />
          <FxComponentWrapper
            isLoading={showLoader}
            loadedComponent={renderPage()}
          />
        </div>
      </div>
    </div>
  );
};

export default Register;
